export const TOAST_ANIMATION_DURATION = 4200;
